import { Action, State, StateContext } from "@ngxs/store";
import { Language } from "../../interfaces/language";
import { Injectable } from '@angular/core';
import { ReportsService } from '../../services/reports.service';
import { LanguageActions } from './language.actions';
import { tap } from 'rxjs/operators';
import { Observable } from 'rxjs';

export class LanguageStateModel {
  public languages: Language[];
}

const defaults = {
  languages: []
}

@State<LanguageStateModel>({
  name: 'languages',
  defaults
})
@Injectable()
export class LanguageState {
  constructor(private reportsService: ReportsService) {}

  @Action(LanguageActions.GetLanguages)
  getLanguages({ getState, setState }: StateContext<LanguageStateModel>): Observable<Language[]> {
    return this.reportsService.getLanguages().pipe(
      tap((languages: Language[]) => {
        const state = getState();
        setState({...state, languages});
      })
    );
  }
}
